// components/StepsToFollow.jsx
"use client";

export default function StepsToFollow() {
  const steps = [
    { step: 1, title: "Register Yourself" },
    { step: 2, title: "Verify Mobile" },
    { step: 3, title: "Fill Application Form Online" },
    { step: 4, title: "Pay Application Fee" },
    { step: 5, title: "Submit Application" },
  ];

  return (
    <section className="bg-[#004760] pb-10 md:pb-14 lg:pb-16">
      <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">
        {/* Heading */}
        <h2 className="text-center text-2xl md:text-3xl font-extrabold text-white tracking-wide">
          STEPS TO FOLLOW
        </h2>

        {/* Steps */}
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-6 text-center text-white">
          {steps.map(({ step, title }) => (
            <div key={step} className="flex flex-col items-center">
              {/* Step label */}
              <p className="mb-2 text-sm font-semibold">Step {step}</p>

              {/* Number + icon card */}
              <div className="relative flex items-center justify-center mb-4">
                {/* Big number */}
                <span className="text-3xl md:text-4xl font-bold text-white/70 mr-2">
                  {String(step).padStart(2, "0")}
                </span>

                {/* Little form-like card */}
                <div className="w-16 h-16 md:w-18 md:h-18 bg-white rounded-md shadow flex flex-col items-center justify-center">
                  <div className="w-10 h-2 rounded-sm bg-gray-300 mb-1" />
                  <div className="w-8 h-1 rounded-sm bg-gray-200 mb-1" />
                  <div className="w-8 h-1 rounded-sm bg-gray-200 mb-3" />
                  <div className="w-12 h-5 rounded-full bg-[#e53935]" />
                </div>
              </div>

              {/* Title */}
              <p className="text-sm md:text-base font-medium max-w-[11rem] mx-auto">
                {title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
